import type { ILocation } from '../shared/location';

export const LocationType = {
  Custom: 'custom',
  Suite: 'suite',
  Reception: 'reception',
  Kitchen: 'kitchen',
  BathRoom: 'bath_room',
  LivingRoom: 'living_room',
  Bedroom: 'bed_room',
  DiningRoom: 'dining_room',
  LaundryRoom: 'laundry_room',
  Garage: 'garage',
  Basement: 'basement',
  Backyard: 'backyard',
  Hallway: 'hallway',
  Closet: 'closet',
  Storage: 'storage',
  UtilityRoom: 'utility_room',
  MechanicalRoom: 'mechanical_room',
} as const;

export type LocationType = (typeof LocationType)[keyof typeof LocationType];

export interface IHomeLocation extends ILocation {
  propertyID: string;
  parentID: string;
  type: LocationType;
}
